  <!--
   功能名称:千里眼平台(技师)-会员管理(会员编辑)
   开发人:梁高权
   创建时间:2021/03/14
   最后修改时间:2021/03/14
   -->
<template>
  <div class="memberEdit-wrap">
    <NavBar/>
    <van-form @submit="onSubmit">
      <div class="form">
        <div class="head">
          <span>手机号码</span>
          <i>{{phone}}</i>
        </div>
        <div class="form-item">
          <div style="width: 300px;">呢称<span style="color:#00CC99">*仅对自己可见</span></div>
          <van-field v-model="member_nick" maxlength="12" input-align="right" name="member_nick"/>
        </div>
        <div class="form-item">
          <div>生日</div>
          <div class="right">{{member_birthday|dateFormat}}
          <!-- <van-icon style="position: relative;top:3px" color="#666666" name="arrow" size="15" /> -->
          </div>
        </div>
        <div class="form-item">
          <div>备注信息</div>
          <div class="right">{{member_remark}}</div>
        </div>
        <div class="form-item" style="display: flex; flex-direction: column;">
          <div style="width: 340px;">兴趣爱好<span style="color:#00CC99">*仅对自己可见</span></div>
          <van-field  v-model="member_like"   autosize type="textarea" maxlength="200" placeholder="请输入兴趣爱好" show-word-limit name="member_like"/>
        </div>
      </div>

      <div style="margin: 16px;">
        <van-button style="border-radius: 8px;" color="#4E57FB" block type="info" native-type="submit">保存</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import table from '@/api/table';
export default {
  name: 'memberEdit',
  components: {'NavBar':() => import('@/components/NavBar')},
  filters: {
    // 格式化日期
    dateFormat(val){
      return (val||'').substring(0,4)+'年'+(val||'').substring(5,7)+'月'+(val||'').substring(8,10)+'日'
    }
  },
  data() {
    return {
      phone:'',
      member_nick: '',
      member_birthday:'',
      member_remark:'',
      member_like:''
    };
  },
  mounted() {
    let {phone, member_nick, member_birthday, member_remark, member_like}=this.$route.query.item;
    this.phone=phone;
    this.member_nick=member_nick;
    this.member_birthday=member_birthday;
    this.member_remark=member_remark;
    this.member_like=member_like
  },
  methods: {
    onSubmit(values) {
      console.log('submit', values);
      values.card_no=this.$route.query.item.card_no
      table.editMember(values).then(response=>{
        if(response.data.result) this.$router.go(-1);//返回上一层
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.memberEdit-wrap {
.form{
  margin: 30px;
  padding: 30px 30px 0;
  border-radius: 16px;
  background: #fff;
  .head{
    display: flex;
    flex-direction: column;
    span{
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 67px;
    }
    i{
      font-size: 36px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 67px;
    }
  }
  .form-item{
    display: flex;
    padding: 25px 0;
    border-bottom: 2px solid #F5F5F5;
    >div:nth-child(1){
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
    }
    .right{
      flex: 1;
      text-align: right;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
  }
}
}
</style>
